import { connect } from 'react-redux';
import CheckoutConfirmation from '../components/Checkout/CheckoutConfirmation';
import { getMemberType } from '../selectors/converterSelector';

const mapStateToProps = function(store) {
    // from template
    return {
        memberType: getMemberType(store),
        orderid: window.orderid,
        showActions: window.showActions,
        approveDate: window.approveDate,
        rejectDate: window.rejectDate,
        buyerContactedDate: window.buyerContactedDate,
        initialOperatorCode: window.decodeJsonFromBase64(window.operatorCode || ''),
        initialResellerPurchaseOrder: window.decodeJsonFromBase64(window.resellerPurchaseOrder || ''),
    };
};
const mapDispatchToProps = function(dispatch, ownProps) {
    return {};
};
const CheckoutConfirmationContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(CheckoutConfirmation);

export default CheckoutConfirmationContainer;
